import * as React from 'react'

const SvgArrowUpLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 3.75V5H5.881L16.25 15.369l-.881.881L5 5.881v7.869H3.75v-10h10z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowUpLeftIcon
